// Serialises a value with object keys sorted, so two objects holding the same
// data give the same string whatever order their keys were written in. The
// browser fingerprint (services/fingerprint.ts) hashes its output, so changing
// what it emits would change every fingerprint recorded from here on. Keep it
// byte-for-byte stable.
export function stableStringify(value: unknown): string {
  if (value === null || typeof value !== "object") return JSON.stringify(value);
  if (Array.isArray(value)) return "[" + value.map(stableStringify).join(",") + "]";
  const obj = value as Record<string, unknown>;
  const keys = Object.keys(obj).sort();
  return "{" + keys.map((k) => JSON.stringify(k) + ":" + stableStringify(obj[k])).join(",") + "}";
}
